import * as React from "react";
const SvgFiRrBell = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-bell_svg__a)">
      <path
        fill="#062147"
        d="m22.556 13.662-1.9-6.836a9.321 9.321 0 0 0-18.08.474l-1.47 6.615A5 5 0 0 0 5.985 20H7.1a5 5 0 0 0 9.8 0h.838a5 5 0 0 0 4.817-6.338M12 22a3 3 0 0 1-2.817-2h5.633A3 3 0 0 1 12 22m8.126-5.185A2.98 2.98 0 0 1 17.737 18H5.988a3.002 3.002 0 0 1-2.929-3.65l1.47-6.617a7.321 7.321 0 0 1 14.2-.372l1.9 6.836a2.98 2.98 0 0 1-.502 2.618"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-bell_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBell;
